<template lang='pug'>
div(:class="{'light-theme': light}")
  router-link.agreement-link(v-if='isAuthenticated' :to='accountRoute.home') {{accountResource.account}}
  template(v-else)
    router-link.agreement-link(:to='accountRoute.login') {{accountResource.login}}
    span.agreement-link-text &nbsp;/&nbsp;
    router-link.agreement-link(:to='accountRoute.register') {{accountResource.register}}
</template>

<script>
import appRoute from '@/router/routes'
import accountResource from '@/resources/account'
import AccountStateMixin from '@/mixins/AccountStateMixin'

export default {
  name: 'AccountOptionsBar',
  mixins: [AccountStateMixin],
  props: {
    light: Boolean
  },
  data: () => ({
    accountRoute: appRoute.account,
    accountResource
  })
}
</script>

<style lang="scss" scoped>
.light-theme .agreement-link,
.light-theme .agreement-link-text {
  color: white;
}

.agreement-link,
.agreement-link-text {
  color: var(--v-accent-base);
  font-size: $link-text-size;
}
</style>
